var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCscustomer = function SvgCscustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.002 20.008a4.449 4.449 0 0 1 4.449-4.448h5.108a4.449 4.449 0 0 1 4.449 4.448M7.002 12.005H2M4 10.004l-2 2.001 2 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.006,
    cy: 8.253,
    r: 4.252,
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};
export { SvgCscustomer as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDY5MzU3ZDIxMDVkNjI2YzM1MDFjODNiMGRlOWJhZDcuc3ZnIjs=";